import { selectionImages } from './collectionPage'

export const selectionCardData = [
  // {
  //   id: '1',
  //   title: 'Квартиры в готовых проектах',
  //   description: 'Дома с инфраструктурой для жизни',
  //   image: selectionImages['1'],
  // },
  // {
  //   id: '2',
  //   title: 'Семейный топ: подборка больших квартир',
  //   description: 'Жильё для больших семей и любителей простора',
  //   image: selectionImages['2'],
  // },
  // {
  //   id: '3',
  //   title: 'Без машины \nкуда угодно',
  //   description: 'Квартиры рядом с метро',
  //   image: selectionImages['3'],
  // },
  {
    id: '4',
    title: 'Квартиры в проектах с PlayHub и LocalPlay',
    description: 'Место для игры и отдыха',
    image: selectionImages['4'],
  },
  {
    id: '5',
    title: 'Квартиры с французскими балконами',
    description: 'Дом, где всегда много света',
    image: selectionImages['5'],
  },
  // {
  //   id: '8',
  //   title: 'Квартиры рядом с парками',
  //   description: 'Жить в городе рядом с природой',
  //   image: selectionImages['8'],
  // },
  {
    id: '9',
    title: 'Жизнь на западе Москвы',
    description: 'Жизнь в престижном районе',
    image: selectionImages['9'],
  },
  {
    id: '10',
    title: 'Шопинг и развлечения рядом',
    description: 'Квартиры около ТРЦ',
    image: selectionImages['10'],
  },
  // {
  //   id: '11',
  //   title: 'Коммерческие помещения',
  //   description: 'Арендный бизнес в готовых домах',
  //   image: selectionImages['11'],
  // },
  // {
  //   id: '12',
  //   title: 'Проекты в Новой Москве',
  //   description: 'Жить в городе рядом с природой',
  //   image: selectionImages['12'],
  // },
  {
    id: '13',
    title: 'Проекты с футбольным полем',
    description: 'Настоящие матчи во дворе дома',
    image: selectionImages['13'],
  },
  // {
  //   id: '16',
  //   title: 'Самые спортивные кварталы ПИК',
  //   description: 'Открытые тренировки',
  //   image: selectionImages['16'],
  // },
  // {
  //   id: '17',
  //   title: 'Продуман каждый метр',
  //   description: 'Квартиры для жизни с комфортом',
  //   image: selectionImages['17'],
  // },
  // {
  //   id: '18',
  //   title: 'Квартиры с 2 санузлами',
  //   description: 'Удобно для большой семьи',
  //   image: selectionImages['18'],
  // },
  {
    id: '19',
    title: 'Квартиры с отделкой',
    description: 'В уже готовых проектах',
    image: selectionImages['19'],
  },
  // {
  //   id: '20',
  //   title: 'Высотки от 30 этажей',
  //   description: 'С панорамным видом на город',
  //   image: selectionImages['20'],
  // },
  {
    id: '21',
    title: 'Самые зеленые проекты ПИК',
    description: 'Проекты рядом с лесами и парками',
    image: selectionImages['21'],
  },
  // {
  //   id: '22',
  //   title: 'Новые школы и детсады',
  //   description: 'Современная учебная среда',
  //   image: selectionImages['22'],
  // },
  // {
  //   id: '23',
  //   title: 'Матвеевский кластер',
  //   description: 'Больше чем просто район',
  //   image: selectionImages['23'],
  // },
  // {
  //   id: '24',
  //   title: 'Доступные квартиры в пределах МКАД',
  //   description: 'Своя квартира в пределах МКАД',
  //   image: selectionImages['24'],
  // },
  {
    id: '26',
    title: 'Проекты ПИК в Подмосковье',
    description: 'Хорошая цена и все плюсы столицы',
    image: selectionImages['26'],
  },
  {
    id: '27',
    title: 'Проекты ПИК от известных архбюро',
    description: 'Индивидуальные дизайны фасадов',
    image: selectionImages['27'],
  },
  // {
  //   id: '25',
  //   title: 'Проекты ПИК+',
  //   description: 'Новый уровень комфорта',
  //   image: selectionImages['25'],
  // },
  // {
  //   id: '28',
  //   title: 'Проекты ПИК для детей',
  //   description: 'Чтобы детям было комфортно',
  //   image: selectionImages['28'],
  // },
  // {
  //   id: '29',
  //   title: 'Проекты с заселением в 2023 году',
  //   description: 'Куда заехать до Нового года',
  //   image: selectionImages['29'],
  // },
  // {
  //   id: '30',
  //   title: 'Квартиры для инвестиций',
  //   description: 'В какой объект вложиться',
  //   image: selectionImages['30'],
  // },
  {
    id: '31',
    title: 'Квартиры на востоке Москвы',
    description: 'В какой объект вложиться',
    image: selectionImages['31'],
  },
  // {
  //   id: '32',
  //   title: 'Квартиры у метро и МЦК',
  //   description: 'Жилье рядом с метро и МЦК',
  //   image: selectionImages['32'],
  // },
  // {
  //   id: '33',
  //   title: 'Что построят в 2024 году',
  //   description: 'Ищем жилье в почти готовых ЖК',
  //   image: selectionImages['33'],
  // },
  // {
  //   id: '34',
  //   title: 'Жить в спортивном режиме',
  //   description: 'Где можно поддерживать форму',
  //   image: selectionImages['34'],
  // },
  // {
  //   id: '35',
  //   title: 'Квартиры, где много света',
  //   description: 'С угловыми и панорамными окнами',
  //   image: selectionImages['35'],
  // },
  // {
  //   id: '36',
  //   title: 'Новоселье раньше срока',
  //   description: 'Проекты с ранним заселением',
  //   image: selectionImages['36'],
  // },
  // {
  //   id: '37',
  //   title: 'Новогоднее настроение',
  //   description: 'Жилые кварталы с елкой во дворе',
  //   image: selectionImages['37'],
  // },
  // {
  //   id: '38',
  //   title: 'Что такое умные планировки',
  //   description: 'Как они делают жизнь удобнее',
  //   image: selectionImages['38'],
  // },
  // {
  //   id: '39',
  //   title: 'Спорт рядом с домом',
  //   description: 'Поселиться рядом c ледовой ареной',
  //   image: selectionImages['39'],
  // },
  // {
  //   id: '40',
  //   title: 'За МКАДом, но в Москве',
  //   description: 'Новостройки с чистым воздухом',
  //   image: selectionImages['40'],
  // },
  // {
  //   id: '41',
  //   title: 'Все необходимое — у дома',
  //   description: 'Дома с развитой инфраструктурой',
  //   image: selectionImages['41'],
  // },
  // {
  //   id: '42',
  //   title: 'Дома для любителей гулять',
  //   description: 'На свежем воздухе и без машин',
  //   image: selectionImages['42'],
  // },
  // {
  //   id: '43',
  //   title: 'Новостройки с шоурумами',
  //   description: 'Оценить будущую квартиру',
  //   image: selectionImages['43'],
  // },
  {
    id: '44',
    title: 'Жить рядом с аквапарком',
    description: 'Чтобы отдыхать чаще',
    image: selectionImages['44'],
  },
  // {
  //   id: '45',
  //   title: 'Топ-7 популярных подборок',
  //   description: 'Топ-7 подборок особенных квартир',
  //   image: selectionImagesTop['40'],
  // },
  // {
  //   id: '46',
  //   title: 'Балконы, лоджии и террасы',
  //   description: 'Заполучить свой «кусочек улицы»',
  //   image: selectionImages['46'],
  // },
  // {
  //   id: '47',
  //   title: 'Заехать в квартиру и жить',
  //   description: 'Почти готовые новостройки',
  //   image: selectionImages['47'],
  // },
  // {
  //   id: '49',
  //   title: 'Особые квартиры Петербурга',
  //   description: 'С планировками для ценителей',
  //   image: selectionImages['49'],
  // },
  // {
  //   id: '50',
  //   title: 'Квартиры с особой отделкой',
  //   description: 'Ремонт высшего качества ПИК+',
  //   image: selectionImages['50'],
  // },
  {
    id: '51',
    title: 'Сделано в России',
    description: 'Из отечественных комплектующих',
    image: selectionImages['51'],
  },
  // {
  //   id: '52',
  //   title: 'Удобные офисы у метро',
  //   description: 'В бизнес-центре на «Озерной»',
  //   image: selectionImages['52'],
  // },
  // {
  //   id: '53',
  //   title: 'Умные планировки',
  //   description: 'Для разных сценариев жизни',
  //   video: {
  //     src: '/videos/collection53/06_47s_loundry_4k_montage.mp4',
  //   },
  // },
  {
    id: '54',
    title: 'Переехать ближе к парку',
    description: 'Новостройки у зеленых массивов',
    image: selectionImages['54'],
  },
  {
    id: '55',
    title: 'Жить у воды',
    description: 'Новостройки у реки или озера',
    image: selectionImages['55'],
  },
  {
    id: '56',
    title: 'Самые популярные кварталы',
    description: 'Новостройки в Московском регионе',
    image: selectionImages['56'],
  },
  {
    id: '7',
    title: 'Квартиры с высокими потолками',
    description: 'Всё о высоких потолках',
    image: selectionImages['7'],
  },
  {
    id: '57',
    title: 'Помещения для бизнеса',
    description: 'На первых этажах в кварталах ПИК',
    video: {
      src: '/videos/collection57/2023-08-21_KH_v2.mp4',
    },
  },
  // {
  //   id: '58',
  //   title: 'Виртуальный шоурум',
  //   description: '«Примерить» квартиру в VR-шлеме',
  //   video: {
  //     src: '/videos/collection58/RBC_PIK_Master_NEW2.mp4',
  //   },
  // },
  {
    id: '15',
    title: 'Проекты рядом с пляжами',
    description: 'Для любителей отдыха у воды',
    image: selectionImages['15'],
  },
  {
    id: '59',
    title: 'Квартиры с гардеробными',
    description: 'Для ежедневного удобства',
    image: selectionImages['59'],
  },
  {
    id: '60',
    title: 'Инфраструктура для спорта',
    description: 'Кварталы со скейт-парками',
    image: selectionImages['60'],
  },
  {
    id: '61',
    title: 'Открытые балконы и террасы',
    description: 'В квартирах новых кварталов ПИК',
    image: selectionImages['61'],
  },
  {
    id: '62',
    title: 'Чем интересна «Серия плюс»',
    description: 'Какие дома вошли в новую линейку',
    image: selectionImages['62'],
  },
  {
    id: '64',
    title: 'Двор-парк: чем заняться',
    description: 'Гамаки, луг для йоги, лавочки',
    image: selectionImages['64'],
  },
  // {
  //   id: '65',
  //   title: 'Грамотно сдать квартиру',
  //   description: 'Самостоятельно без риелтора',
  //   image: selectionImages['65'],
  // },
  {
    id: '66',
    title: 'Площадки для баскетбола',
    description: 'Рядом с домом в кварталах ПИК',
    image: selectionImages['66'],
  },
  {
    id: '6',
    title: 'Дома рядом с вузами',
    description: 'Дорога займет не больше 30 минут',
    image: selectionImages['6'],
  },
  {
    id: '14',
    title: 'Апартаменты «Вольта»',
    description: 'Недвижимость для инвестиций',
    image: selectionImages['14'],
  },
  // {
  //   id: '48',
  //   title: 'Жить в культурной столице',
  //   description: 'Новостройки в центре Петербурга',
  //   image: selectionImages['48'],
  // },
  {
    id: '63',
    title: 'На Васильевском острове',
    description: 'Поселиться у Финского залива',
    image: selectionImages['63'],
  },
  {
    id: '67',
    title: 'Террасы и патио в СПб',
    description: 'Своя терраса в Петербурге',
    image: selectionImages['67'],
  },
  {
    id: '68',
    title: 'Чем заняться детям',
    description: 'Почему детям интересно во дворах ПИК',
    image: selectionImages['68'],
  },
  {
    id: '69',
    title: 'Вариант для инвестиций',
    description: 'Апартаменты для инвестиций',
    image: selectionImages['69'],
  },
  // {
  //   id: '70',
  //   title: '«Серия плюс» изнутри',
  //   description: 'Чем интересна «Серия плюс»',
  //   image: selectionImages['70'],
  // },
  {
    id: '71',
    title: 'Жилье в Подмосковье',
    description: 'Поселиться в Подмосковье',
    image: selectionImages['71'],
  },
  {
    id: '72',
    title: '8 новых школ и 6 детских садов',
    description: 'Открылись в кварталах ПИК',
    image: selectionImages['72'],
  },
  {
    id: '73',
    title: 'Детские площадки 2.0',
    description: 'Игровые зоны нового поколения',
    video: {
      src: '/videos/collection73/1.mp4',
    },
  },
  // {
  //   id: '74',
  //   title: 'Выгодные квартиры',
  //   description: 'По Семейной ипотеке',
  //   image: selectionImages['74'],
  // },
  {
    id: '76',
    title: 'Помещения с арендаторами',
    description: 'Готовый бизнес в новостройке',
    image: selectionImages['76'],
  },
  // {
  //   id: '77',
  //   title: ' Готовые квартиры в ипотеку',
  //   description: 'С ежемесячным платежом от ₽19 600 в месяц',
  //   image: selectionImages['77'],
  // },
  {
    id: '78',
    title: 'Готовые квартиры',
    description: 'Варианты с техникой и мебелью',
    image: selectionImages['78'],
  },
  {
    id: '79',
    title: 'Коммерческие помещения',
    description: 'Сдать в аренду и зарабатывать',
    image: selectionImages['79'],
  },
  {
    id: '80',
    title: '«Москворечье»: новые дома',
    description: 'Начались продажи видовых квартир',
    image: selectionImages['80'],
  },
  {
    id: '81',
    title: 'Видовые квартиры ПИК',
    description: 'В зеленых районах Москвы',
    image: selectionImages['81'],
  },
  {
    id: '82',
    title: 'Высоколиквидные помещения',
    description: 'В Петербурге на первых этажах',
    image: selectionImages['82'],
  },
  {
    id: '83',
    title: 'Как меняется восток Москвы',
    description: 'С новыми кварталами ПИК',
    image: selectionImages['83'],
  },
  {
    id: '84',
    title: '«Саларьево Парк»: новые корпуса',
    description: 'Редкий шанс выгодной покупки',
    image: selectionImages['84'],
  },
  {
    id: '85',
    title: 'Новые квартиры с ремонтом',
    description: 'В перспективных районах Москвы',
    image: selectionImages['85'],
  },
  // {
  //   id: '86',
  //   title: ' Заселиться до конца года',
  //   description: 'В готовую квартиру ПИК',
  //   image: selectionImages['86'],
  // },
  {
    id: '87',
    title: 'Кварталы у лыжных склонов',
    description: 'Где поселиться любителям спорта',
    image: selectionImages['87'],
  },
  {
    id: '88',
    title: 'Квартиры «Серии Плюс»',
    description: 'С продуманными планировками',
    image: selectionImages['88'],
  },
  {
    id: '89',
    title: 'Семейная ипотека',
    description: 'Какие варианты доступны в 2025-м',
    image: selectionImages['89'],
  },
  {
    id: '90',
    title: 'Кварталы, где все устроено',
    description: 'Заселиться и радоваться жизни',
    image: selectionImages['90'],
  },
  {
    id: '91',
    title: 'Коммерческие помещения',
    description: 'Подойдут для магазина и кафе',
    image: selectionImages['91'],
  },
  {
    id: '92',
    title: 'Кварталы ПИК на юге Москвы',
    description: 'В экологичных районах столицы',
    image: selectionImages['92'],
  },
  {
    id: '93',
    title: 'Куда инвестировать в 2025',
    description: 'Кварталы, которые скоро достроят',
    image: selectionImages['93'],
  },
  {
    id: '94',
    title: 'Квартиры для инвестиций',
    description: 'По выгодным ценам. Старт продаж',
    image: selectionImages['94'],
  },
  // {
  //   id: '95',
  //   title: 'Помещения в готовых домах',
  //   description: 'Для бизнеса или сдачи в аренду',
  //   image: selectionImages['95'],
  // },
  {
    id: '75',
    title: 'Готовые квартиры с выгодой',
    description: 'Ключи сразу после покупки',
    image: selectionImages['75'],
  },
  // для якоря на всю неделю, также надо убрать эту подборку выше из списка чтобы не было дубля
]
